/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';
import * as moment from 'moment';

import BUILD_INFO from '../../gen-config/build-info';
import {WINDOW} from '../angular-platform-providers';

const RELOAD_DELAY_MS = 125;

interface BuildInfo {
  gitSha: string;
  buildTime: string;
}

type BuildInfoWindow = Window & {
  CURRENT_BUILD_INFO?: BuildInfo;
};

@Injectable({providedIn: 'root'})
export class BuildReloadService {
  private reloadScheduled = false;

  constructor(
    @Inject(WINDOW) private readonly window: BuildInfoWindow
  ) {
  }

  reloadIfNewerBuild(): boolean {
    if (this.reloadScheduled || !this.hasNewerBuild()) {
      return this.reloadScheduled;
    }

    this.reloadScheduled = true;
    setTimeout(() => this.window.location.reload(), RELOAD_DELAY_MS);
    return true;
  }

  private hasNewerBuild(): boolean {
    const currentBuild = this.window.CURRENT_BUILD_INFO;
    return !!currentBuild
      && currentBuild.gitSha !== BUILD_INFO.gitSha
      && moment(currentBuild.buildTime).isAfter(BUILD_INFO.buildTime);
  }
}
